export default {
  premium: {
    en: 'Premium',
  },
}
